import { render, staticRenderFns } from "./DataCuesCard.vue?vue&type=template&id=edc24efc&scoped=true"
import script from "./DataCuesCard.vue?vue&type=script&lang=js"
export * from "./DataCuesCard.vue?vue&type=script&lang=js"
import style0 from "./DataCuesCard.scss?vue&type=style&index=0&id=edc24efc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc24efc",
  null
  
)

export default component.exports